
import React from "react";
import Header from "@/components/Header";
import { TradingFeed } from "@/components/TradingFeed";
import { useIsMobile } from "@/hooks/use-mobile";

const Index: React.FC = () => {
  const isMobile = useIsMobile();

  return (
    <div className="min-h-screen flex flex-col bg-background text-foreground">
      <Header />
      <main className={`flex-1 py-1 ${isMobile ? "mobile-scroll-container" : "overflow-y-auto overflow-x-hidden home-class"}`}>
        <TradingFeed />
      </main>
    </div>
  );
};

export default Index;
